<script>

    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import ModalContainer from '../$components/modal.container.svelte'

    import UsersComponent from './component.users.svelte'
    import Create from './component.create.svelte'

    if(!isPermission($adminStore, 'UsersView'))
        replace('/404')

</script>

<View>
    <PageHeader title="Usuarios" subtitle="Administra los usuarios de la plataforma" />
    <UsersComponent />
</View>

<ModalContainer id="users_create_modal" title="Crear usuario">
    <Create />
</ModalContainer>
